import { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';

const services = [
  {
    icon: 'ri-layout-4-line',
    title: 'WEBサイト制作',
    subtitle: 'Web Design & Development',
    description:
      'コーポレートサイト・LP・ECサイトまで、集客と成約につながる戦略的なWEBを一貫制作します。',
    accentColor: '#1E6FFF',
    gradientFrom: '#E8F0FF',
    gradientTo: '#F0F5FF',
    href: '/services#web',
    stat: '最短2週間',
    statLabel: '公開実績あり',
    number: '01',
    image: 'https://readdy.ai/api/search-image?query=modern%20web%20design%20workspace%20with%20laptop%20displaying%20elegant%20website%20mockup%2C%20clean%20minimalist%20desk%20setup%2C%20soft%20blue%20ambient%20lighting%2C%20professional%20digital%20agency%20atmosphere%2C%20floating%20UI%20elements%20and%20code%20snippets%2C%20tech%20startup%20aesthetic%2C%20dark%20navy%20blue%20and%20white%20color%20scheme%2C%20high-end%20corporate%20website%20design%20on%20screen%2C%20creative%20professional%20environment%2C%20no%20people&width=800&height=500&seq=service-web-design-01&orientation=landscape',
  },
  {
    icon: 'ri-instagram-line',
    title: 'SNS運用代行',
    subtitle: 'Social Media Management',
    description:
      'Instagram・X・FacebookなどのSNSをまるごとお任せ。フォロワー増加・ブランド強化を実現します。',
    accentColor: '#0099FF',
    gradientFrom: '#E5F5FF',
    gradientTo: '#EEF8FF',
    href: '/services#sns',
    stat: '150% UP',
    statLabel: '平均フォロワー増加',
    number: '02',
    image: 'https://readdy.ai/api/search-image?query=social%20media%20management%20concept%20with%20multiple%20screens%20showing%20Instagram%20and%20Twitter%20feeds%2C%20engagement%20graphs%20and%20follower%20growth%20charts%2C%20professional%20digital%20agency%20workspace%2C%20soft%20blue%20ambient%20lighting%2C%20dark%20navy%20blue%20background%20with%20glowing%20cyan%20and%20electric%20blue%20accents%2C%20floating%20social%20media%20icons%20and%20analytics%20metrics%2C%20tech%20corporate%20atmosphere%2C%20futuristic%20marketing%20technology%20aesthetic%2C%20no%20people&width=800&height=500&seq=service-sns-tech-navy-2026&orientation=landscape',
  },
  {
    icon: 'ri-bar-chart-grouped-line',
    title: 'デジタルマーケティング',
    subtitle: 'Digital Marketing',
    description:
      'SEO・MEO・Web広告など、データに基づいたデジタル集客施策で費用対効果を最大化します。',
    accentColor: '#1E6FFF',
    gradientFrom: '#E8F0FF',
    gradientTo: '#F0F5FF',
    href: '/services#marketing',
    stat: '3ヶ月',
    statLabel: '成果が出るまでの目安',
    number: '03',
    image: 'https://readdy.ai/api/search-image?query=digital%20marketing%20analytics%20dashboard%20with%20growth%20charts%20and%20data%20visualization%2C%20modern%20business%20intelligence%20interface%2C%20floating%20SEO%20and%20performance%20metrics%2C%20professional%20marketing%20strategy%20concept%2C%20soft%20blue%20ambient%20lighting%2C%20tech%20corporate%20atmosphere%2C%20data-driven%20decision%20making%20aesthetic%2C%20navy%20blue%20and%20cyan%20color%20scheme%2C%20abstract%20digital%20network%20connections%2C%20futuristic%20marketing%20technology%2C%20no%20people&width=800&height=500&seq=service-digital-marketing-01&orientation=landscape',
  },
];

export default function HomeServices() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll('.hs-header').forEach((el) => {
              (el as HTMLElement).style.opacity = '1';
              (el as HTMLElement).style.transform = 'translateY(0)';
            });
            entry.target.querySelectorAll('.hs-card').forEach((el, i) => {
              setTimeout(() => {
                (el as HTMLElement).style.opacity = '1';
                (el as HTMLElement).style.transform = 'translateY(0) scale(1)';
              }, i * 160 + 200);
            });
          }
        });
      },
      { threshold: 0.1 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <>
      <style>{`
        .hs-header {
          opacity: 0;
          transform: translateY(32px);
          transition: opacity 0.8s ease, transform 0.8s ease;
        }
        .hs-card {
          opacity: 0;
          transform: translateY(44px) scale(0.97);
          transition: opacity 0.65s ease, transform 0.65s ease,
                      box-shadow 0.35s ease;
        }
        .hs-card:hover {
          transform: translateY(-10px) scale(1.01) !important;
          box-shadow: 0 24px 64px rgba(30,111,255,0.12);
        }
        .hs-icon {
          transition: transform 0.4s cubic-bezier(0.34, 1.56, 0.64, 1),
                      background 0.3s ease;
        }
        .hs-card:hover .hs-icon {
          transform: scale(1.18) rotate(-10deg);
        }
        .hs-arrow {
          display: inline-block;
          transition: transform 0.3s ease;
        }
        .hs-card:hover .hs-arrow {
          transform: translateX(8px);
        }
        .hs-stat {
          transition: transform 0.3s ease, box-shadow 0.3s ease;
        }
        .hs-card:hover .hs-stat {
          transform: scale(1.04);
        }
        .hs-number {
          transition: opacity 0.4s ease, transform 0.4s ease;
        }
        .hs-card:hover .hs-number {
          opacity: 0.08 !important;
          transform: scale(1.08) translateY(-6px);
        }
        .hs-underline {
          display: block;
          height: 2px;
          width: 0;
          background: linear-gradient(90deg, #1E6FFF, #0099FF);
          transition: width 0.3s ease;
          margin-top: 2px;
        }
        .hs-card:hover .hs-underline {
          width: 100%;
        }
        .hs-image {
          transition: transform 0.6s ease;
        }
        .hs-card:hover .hs-image {
          transform: scale(1.08);
        }
        @keyframes hs-float-a {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          33% { transform: translateY(-18px) translateX(8px); }
          66% { transform: translateY(-8px) translateX(-6px); }
        }
        @keyframes hs-float-b {
          0%, 100% { transform: translateY(0px) translateX(0px); }
          50% { transform: translateY(-14px) translateX(-10px); }
        }
        .hs-orb-a {
          animation: hs-float-a 9s ease-in-out infinite;
        }
        .hs-orb-b {
          animation: hs-float-b 7s ease-in-out infinite;
          animation-delay: 2s;
        }
      `}</style>

      <section className="py-28 bg-white relative overflow-hidden" ref={sectionRef}>
        {/* Decorative floating orbs */}
        <div
          className="hs-orb-a absolute -top-40 -right-40 w-[28rem] h-[28rem] rounded-full pointer-events-none"
          style={{
            background: 'radial-gradient(circle, rgba(30,111,255,0.07) 0%, transparent 70%)',
          }}
        />
        <div
          className="hs-orb-b absolute -bottom-32 -left-32 w-96 h-96 rounded-full pointer-events-none"
          style={{
            background: 'radial-gradient(circle, rgba(0,153,255,0.06) 0%, transparent 70%)',
          }}
        />

        <div className="max-w-7xl mx-auto px-6 md:px-10 relative z-10">
          {/* Header */}
          <div className="hs-header mb-16 md:mb-20 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <div>
              <p className="text-[#1E6FFF] text-xs tracking-[0.3em] mb-4 uppercase">
                / Services
              </p>
              <h2 className="text-4xl md:text-5xl font-bold text-[#0A1628] tracking-tight leading-tight">
                提供サービス
              </h2>
            </div>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 text-sm text-[#1E6FFF] font-medium hover:gap-4 transition-all whitespace-nowrap group"
            >
              サービス一覧を見る
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </Link>
          </div>

          {/* Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            {services.map((s) => (
              <Link
                key={s.title}
                to={s.href}
                className="hs-card rounded-2xl overflow-hidden cursor-pointer block relative"
                style={{ background: `linear-gradient(135deg, ${s.gradientFrom} 0%, ${s.gradientTo} 100%)` }}
              >
                {/* Big decorative number */}
                <div
                  className="hs-number absolute top-3 right-4 text-9xl font-black leading-none select-none pointer-events-none"
                  style={{ color: s.accentColor, opacity: 0.05 }}
                >
                  {s.number}
                </div>

                {/* Service Image */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={s.image}
                    alt={s.title}
                    className="hs-image w-full h-full object-cover object-center"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-white/80 via-transparent to-transparent" />
                </div>

                <div className="p-8 md:p-10 relative z-10 -mt-8">
                  {/* Icon */}
                  <div
                    className="hs-icon w-14 h-14 flex items-center justify-center rounded-xl mb-7"
                    style={{ background: `linear-gradient(135deg, ${s.accentColor} 0%, #0099FF 100%)` }}
                  >
                    <i className={`${s.icon} text-2xl text-white`} />
                  </div>

                  <p className="text-[#1E6FFF] text-xs tracking-[0.2em] mb-2 uppercase">
                    {s.subtitle}
                  </p>
                  <h3 className="text-xl font-bold text-[#0A1628] leading-snug mb-4">
                    {s.title}
                  </h3>
                  <p className="text-[#555] text-sm leading-relaxed mb-7">
                    {s.description}
                  </p>

                  {/* Stat badge */}
                  <div
                    className="hs-stat inline-flex flex-col items-start px-4 py-3 rounded-xl"
                    style={{
                      backgroundColor: `${s.accentColor}15`,
                      border: `1px solid ${s.accentColor}30`,
                    }}
                  >
                    <span
                      className="text-lg font-black leading-tight tracking-tight"
                      style={{ color: s.accentColor }}
                    >
                      {s.stat}
                    </span>
                    <span className="text-xs text-[#999] mt-0.5">{s.statLabel}</span>
                  </div>
                </div>

                {/* Footer link */}
                <div className="px-8 md:px-10 pb-8 md:pb-10 relative z-10">
                  <span className="text-[#1E6FFF] text-sm font-semibold inline-flex items-center gap-2">
                    詳しく見る
                    <i className="ri-arrow-right-line hs-arrow" />
                  </span>
                  <span className="hs-underline" />
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}